<app-selected-filters-cont #stickyRef
  [class]="classProvider"
  [viewSelectedFilters]="shouldShowFilters$ | async"
  [inFilterBar]="inFilterBar"
  [isMobile]="isMobile"
  [sticky]="sticky">
  <ul selectedFilters="selectedFilters">
    <ng-container [ngSwitch]="provider">
      <ng-container *ngSwitchCase="packageFilterProvider.HOTEL">
        <ng-container *ngTemplateOutlet="hotelTemplate"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="airTemplate"></ng-container>
      </ng-container>
    </ng-container>
  </ul>
</app-selected-filters-cont>

<ng-template #airTemplate>
  <ng-container *ngFor="let filter of airFilters$ | async; trackBy: trackById">
    <ng-container *ngIf="isSectionCheckBoxAirFilter(filter)">
      <ng-container *ngTemplateOutlet="airSectorType; context: { filter: filter }">
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isRangeAirFilter(filter)">
      <ng-container *ngTemplateOutlet="airRangeType; context: { filter: filter }">
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isCheckboxAirFilter(filter)">
      <ng-container *ngTemplateOutlet="airCheckboxtype; context: { filter: filter }">
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #hotelTemplate>
  <ng-container *ngIf="hasHotelNameSearch$ | async">
    <ng-container *ngTemplateOutlet="hotelNameInputType"></ng-container>
  </ng-container>
  <ng-container *ngFor="let filter of hotelFilters$ | async; trackBy: trackById">
    <ng-container *ngIf="isHotelCheckboxFilterTypes(filter)">
      <ng-container *ngTemplateOutlet="hotelCheckboxType; context: { filter: filter }">
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isRangeHotelFilter(filter)">
      <ng-container *ngTemplateOutlet="hotelRangeType; context: { filter: filter }">
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isRadioHotelFilter(filter)">
      <ng-container *ngTemplateOutlet="radioFilterTemplate; context: { filter: filter }">
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isHotelSorter(filter)">
      <ng-container *ngTemplateOutlet="sorterFilterTemplate; context: { filter: filter }">
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #hotelCheckboxType let-filter='filter'>
  <ng-container *ngFor="let item of filter.value">
    <ol *ngIf="checkedHotelCheckbox$(item, filter.type, isCheckboxHotelFilter(filter)) | async">
      <li>
        <app-filter-bar-tag
          [class.active]="true"
          [isActive]="true"
          [isMultipleSelection]="false"
          [label]="getHotelCheckboxLabel(item, filter.type)"
          (clickEvent)="removeHotelCheckboxFilter(item, filter.type, isCheckboxHotelFilter(filter))">
        </app-filter-bar-tag>
      </li>
    </ol>
  </ng-container>
</ng-template>

<ng-template #hotelRangeType let-filter='filter'>
  <ol *ngIf="(checkedHotelRanges$(filter.type) | async) as range" >
    <li>
      <app-filter-bar-tag
        [class.active]="true"
        [isActive]="true"
        [isMultipleSelection]="false"
        [label]="(getHotelRangeItemLabel(filter.type) | transloco) + ': ' + (range[0] | priceAbbreviation) + ' - ' + (range[1] | priceAbbreviation)"
        (clickEvent)="removeHotelRangeFilter(filter.type)">
      </app-filter-bar-tag>
    </li>
  </ol>
</ng-template>

<ng-template #hotelNameInputType>
  <ol>
    <li>
      <app-filter-bar-tag
        [class.active]="true"
        [isActive]="true"
        [isMultipleSelection]="false"
        [label]="hotelNameSearch$ | async"
        (clickEvent)="removeHotelNameFilter()">
      </app-filter-bar-tag>
    </li>
  </ol>
</ng-template>

<ng-template #radioFilterTemplate let-filter='filter'>
  <ng-container [ngSwitch]="filter.type">
    <ng-container *ngSwitchCase="hotelFilterTypes.PromotionalRates">
      <ol *ngIf="checkedRadioHotelFilter$(filter) | async" >
        <li>
          <app-filter-bar-tag
            [class.active]="true"
            [isActive]="true"
            [isMultipleSelection]="false"
            [label]="totalDiscountPercentageText$(filter) | async"
            (clickEvent)="removeDiscountFilter()">
          </app-filter-bar-tag>
        </li> 
      </ol>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #sorterFilterTemplate let-filter='filter'>
  <ol *ngIf="checkedHotelSorter$(filter) | async as sorter">
    <li>
      <app-filter-bar-tag
          [class.active]="true"
          [isActive]="true"
          [isMultipleSelection]="true"
          [label]="sorter.Label | transloco"
          (clickEvent)="toggleSorterSelection(filter)">
      </app-filter-bar-tag>
    </li>
  </ol>
</ng-template>

<ng-template #airSectorType let-filter='filter'>
  <ng-container *ngFor="let item of filter.value">
    <ng-container *ngFor="let airport of item.Airports">
      <ol *ngIf="checkedAirport$(airport.Text, filter.type) | async">
        <li class="airport-filter">
          <app-filter-bar-tag
            [class.active]="true"
            [isActive]="true"
            [isMultipleSelection]="false"
            [label]="getSectorFilterLabel(filter.type, item.SectorNumber, airport.AirportName)"
            (clickEvent)="removeAirportCheckboxFilter(airport.Text, item.SectorNumber, filter.type)">
          </app-filter-bar-tag>
        </li>
      </ol>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #airRangeType let-filter='filter'>
  <ol *ngIf="(airRangeIsChecked$(filter.type) | async)" >
    <li>
      <app-filter-bar-tag
        [class.active]="true"
        [isActive]="true"
        [isMultipleSelection]="false"
        [label]="(getAirItemLabel(filter.type) | transloco) + ': ' + ((checkedAirRanges$(filter.type) | async)?.[0] | priceAbbreviation) + ' - ' + ((checkedAirRanges$(filter.type) | async)?.[1] | priceAbbreviation)"
        (clickEvent)="removeAirRangeFilter(filter.type)">
      </app-filter-bar-tag>
    </li>
  </ol>
  <ng-container *ngIf="(airComplexRangeIsChecked$(filter.type) | async)">
    <ng-container *ngFor="let r of (checkedAirComplexRanges$(filter.type) | async); let i = index">
      <ol *ngIf="r && r.length" >
        <li>
          <app-filter-bar-tag
            [class.active]="true"
            [isActive]="true"
            [isMultipleSelection]="false"
            [label]="(getAirItemLabel(filter.type) | transloco: { filterCriteria: getCriteria(filter.type, i) }) + ': ' + (r[0] | rangeType: getRangeType(filter.type)) + ' - ' + (r[1] | rangeType: getRangeType(filter.type))"
            (clickEvent)="removeAirComplexRangeFilter(filter.type, i+1)">
          </app-filter-bar-tag>
        </li>
      </ol>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #airCheckboxtype let-filter='filter'>
  <ng-container *ngFor="let item of filter.value">
    <ol *ngIf="checkedAirCheckbox$(item, filter.type, isCheckboxAirFilter(filter)) | async">
      <li>
        <ng-container *ngIf="withTranslationsInAirFilters(filter.type); else withoutTranslationTemplateLabel">
          <ng-container *ngTemplateOutlet="airCheckboxTypeTag; context: { label: getAirCheckboxLabelTranslations(item, filter.type) }"></ng-container>
        </ng-container>
        <ng-template #withoutTranslationTemplateLabel>
          <ng-container *ngTemplateOutlet="airCheckboxTypeTag; context: { label: getAirCheckboxLabel(item) }"></ng-container>
        </ng-template>
        <ng-template #airCheckboxTypeTag let-label="label">
          <app-filter-bar-tag
            [class.active]="true"
            [isActive]="true"
            [isMultipleSelection]="false"
            [label]="label"
            (clickEvent)="removeAirCheckboxFilter(item, filter.type, isCheckboxAirFilter(filter))">
          </app-filter-bar-tag>
        </ng-template>
      </li>
    </ol>
  </ng-container>
</ng-template>
